<template>
  <div
    v-if="giftcard.product_variation"
    class="d-flex flex-column border rounded mb-4"
    :class="{
      'bg-lightest border-light': giftcard.redeemed_at === null,
      'bg-pink border-lightest text-muted used': used || expired,
    }"
  >
    <div class="px-3 px-sm-4 py-3">
      <h5 class="d-flex align-items-center w-100 justify-content-between">
        <div>
          <gift-svg class="d-none d-sm-inline mr-3" />
          <span>{{ giftcard.product_variation.product.name }}</span>
        </div>
        <transition name="fade">
          <div
            class="date-box d-none d-sm-block hoverable"
            v-if="experienceDate"
            v-b-tooltip.hover.bottom
            :title="
              `Du har oppgitt ${formatDateBox} som tidspunkt for gjennomføring av opplevelsen. Kunden mottar en bekreftelse ved innløst verdibevis og dagen etter gjennomføringen ber vi kunden gi dere en brukeromtale.`
            "
          >
            <span class="date-icon">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </span>
            {{ formatDateBox }}
          </div>
        </transition>
      </h5>
      <span
        class="d-inline-block d-sm-none small hoverable"
        v-b-tooltip.hover.bottom
        :title="
          `Du har oppgitt ${formatDateBox} som tidspunkt for gjennomføring av opplevelsen. Kunden mottar en bekreftelse ved innløst verdibevis og dagen etter gjennomføringen ber vi kunden gi dere en brukeromtale.`
        "
      >
        <i class="fa fa-calendar mr-1" aria-hidden="true"></i> {{ formatDateBox }}
      </span>
      <div class="row mt-4">
        <div class="col-6 col-sm-4" v-if="giftcard.booking_info">
          <p>
            <strong>Navn</strong><br /><span
              >{{ giftcard.booking_info.first_name }}
              {{ giftcard.booking_info.last_name }}</span
            >
          </p>
        </div>
        <div class="col-6 col-sm-4">
          <p>
            <strong>Gyldig for</strong><br />{{ giftcard.product_variation.participants }}
            {{ giftcard.product_variation.participants > 1 ? 'personer' : 'person' }}
          </p>
        </div>
        <div class="col-6 col-sm-4">
          <p><strong>Varighet</strong><br />{{ giftcard.product_variation.duration }}</p>
        </div>
        <div class="col-6 col-sm-4">
          <p><strong>Solgt for</strong><br />{{ Number(giftcard.order_detail.price.amount / 100).toFixed(2) }} kr</p>
        </div>
        <div class="col-6 col-sm-4">
          <p><strong>Verdibevis</strong><br />{{ giftcard.code }}</p>
        </div>
        <div class="col-6 col-sm-4">
          <p v-if="giftcard.redeemed_at === null">
            <strong>Gyldig til</strong><br />{{ formatDate(giftcard.valid_to) }}
          </p>
          <p v-if="giftcard.redeemed_at"><strong>Løst inn</strong><br />{{ formatDate(giftcard.used_at) }}</p>
        </div>
      </div>
    </div>
    <div v-if="used">
      <b-button block class="voucher-btn" v-if="giftcard.exchanged_at" disabled variant="danger"
        >Byttet</b-button
      >
      <b-button block class="voucher-btn" v-if="giftcard.order_detail.refunded_at" disabled variant="danger"
        >Återbetalt</b-button
      >
      <b-button block class="voucher-btn" v-if="giftcard.redeemed_at" disabled variant="danger"
        >Løst inn</b-button
      >
    </div>
    <div v-else-if="expired">
      <b-button block class="voucher-btn" disabled variant="danger">Utløpt</b-button>
    </div>
    <div v-else>
      <b-button block class="voucher-btn" @click="useCode" variant="primary">Løs inn</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GiftSvg from '@/components/svg/Gift.vue';
import { isAfter, parseISO, format } from 'date-fns/fp';
import dayjs from 'dayjs';
import 'dayjs/locale/nb'; // load on demand

export default {
  props: ['giftcard', 'experienced_date'],
  computed: {
    ...mapGetters({
      experienceDate: 'vouchers/experienced_at',
    }),
    used() {
      return this.giftcard.redeemed_at !== null;
    },
    expired() {
      return isAfter(parseISO(this.giftcard.valid_to), new Date());
    },
    formatDateBox() {
      return dayjs(this.experienceDate)
        .locale('nb')
        .format('dddd DD-MM-YYYY klokken HH:mm');
    },
  },
  data() {
    return {};
  },
  components: {
    GiftSvg,
  },
  methods: {
    useCode() {
      this.$emit('use', this.giftcard);
    },
  },
};
</script>

<style>
.btn {
  white-space: nowrap;
}

.voucher-btn {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.used {
  text-decoration: line-through;
  background-color: #eacfcf;
}

.date-box {
  margin-top: -1.5rem;
  margin-right: -1.5rem;
  font-size: 13px;
  line-height: 23px;
  background-color: #e7e7e7;
  padding: 5px 10px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  font-weight: 300;
}

.date-box i {
  margin-right: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
